module.exports = __webpack_public_path__ + "img/top_curve.2b05fddb.svg";